import { api } from '../api';
import { toast } from 'react-toastify';

export async function getHolidays(dt_ini, dt_fim) {
    try {
        const { data } = await api.get(`/feriado?dt_ini=${dt_ini}&dt_fim=${dt_fim}`);
        return data;
    } catch (error) {
        return false;
    }
}

export async function createHoliday(holiday) {
    try {
        const { data } = await api.post(`/feriado?dt_feriado=${holiday?.date}&mensagem=${holiday?.message}&nome=${holiday?.name}`);
        return {
            status_code: 201,
            dt_feriado: holiday?.date,
            mensagem: holiday?.message,
            nome: holiday?.name
        };
    } catch (error) {
        const message = error?.response?.data;
        if (message) {
            return {
                status_code: error.response.status,
                dt_feriado: holiday?.date,
                mensagem: holiday?.message,
                nome: holiday?.name
            };
        }
        return {
            status_code: 500,
            message: 'Erro ao cadastrar feriado'
        };
    }
}

export async function updateHoliday(holiday) {
    try {
        const { data } = await api.put(`/feriado?dt_feriado=${holiday?.date}&mensagem=${holiday?.message}&nome=${holiday?.name}`)
        if (data?.status_code === 201) {
            return {
                status_code: 201,
                dt_feriado: holiday?.date,
                mensagem: holiday?.message,
                nome: holiday?.name
            }
        }
    }
    catch (error) {
        const { data: message } = error?.response;
        if (message) {
            return {
                status_code: 401 || 400,
                dt_feriado: holiday?.date,
                mensagem: holiday?.message,
                nome: holiday?.name
            }
        }
        return {
            status_code: 500,
            message: 'Erro ao alterar feriado '
        }
    }
};

export async function disableHoliday(holidayID) {
    try {
        await api.delete(`/feriado?id=${holidayID}`)
        return true;
    }
    catch (error) {
        // toast.error(
        //     `Erro ao excluir feriado `,
        //     {
        //         position: "top-center",
        //         theme: "colored",
        //     }
        // );
    }
};